$ = require 'jquery'
Singleton = require '../../pattern/singleton'
Elements = require './elements'
SpriteAnime = require './sprite-anime'

module.exports =
class HeroAnime extends Singleton

  selector      : '.section-hero'
  scrollSelector: '.guide-scroll'
  logoSelector  : '.hero-logo'

  constructor: ->
    super

    @$window = Elements.$window
      .one
        'pagesLoaded': @onPagesLoaded
        'heroBgEnded': @onHeroBgEnded
        'splashEnded': @onSplashEnded

    @spriteAnime = new SpriteAnime @logoSelector

  onPagesLoaded: =>
    @$section = $ @selector
    @$scroll  = @$section.find @scrollSelector
      .css 'display', 'none'

  onHeroBgEnded: =>
    @spriteAnime.start () =>
      @$window.trigger 'heroAnimeEnded'

  onSplashEnded: =>
    @$scroll.velocity
      scale: [ 1, 0 ]
    ,
      duration: 300
      easing  : 'easeOutBack'
      display : 'block'



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/hero-anime.coffee